import { RouteRecordRaw } from "vue-router";

const publicRoutes: Array<RouteRecordRaw> = [
  // {
  // path: '/api/login/idp/success',
  // redirect: (to) => {
  //   const { id, token } = to.query;
  //   return {
  //     path: '/login/sso/success',
  //     query: { id, token },
  //   };
  // },
  // },
  {
    path: "/push",
    alias: "/push",
    name: "push",
    components: { public: () => import('@/views/pushnotificationtest/PushView.vue') },
    meta: { titleKey: 'page_titles.sso_success', requiresAuth: false },
  },
  {
    path: "/login/sso/success",
    alias: "/login/sso/success",
    name: "login-sso-success",
    components: { public: () => import('@/views/public/SSO/SuccessView.vue') },
    meta: { titleKey: 'page_titles.sso_success', requiresAuth: false },
  },
  {
    path: '/login/sso/fail',
    alias: "/login/sso/fail",
    name: 'SSOFail',
    components:  { public: () => import('@/views/public/SSO/FailView.vue') },
    meta: { titleKey: 'page_titles.sso_fail', requiresAuth: false },
  },
  {
    path: "/",
    alias: "/welcome",
    name: "welcome",
    components: { public: () => import("@/views/public/StartView.vue") },
    meta: { titleKey: 'page_titles.welcome', requiresAuth: false },
  },
  // {
  //   path: "/signup-login",
  //   alias: "/signup-login",
  //   name: "signup-login",
  //   components: { public: () => import("@/views/public/SignUpOrLoginView.vue") },
  //   meta: { titleKey: 'page_titles.signup_login', requiresAuth: false },
  // },
  {
    path: "/sign-up",
    alias: "/sign-up",
    name: "sign-up",
    components: { public: () => import("@/views/public/SignUp/SignUpView.vue") },
    meta: { titleKey: 'page_titles.sign_up', requiresAuth: false },
  },
  {
    path: "/sign-in",
    alias: "/sign-in",
    name: "sign-in",
    components: { public: () => import("@/views/public/SignIn/SignInView.vue") },
    meta: { titleKey: 'page_titles.sign_in', requiresAuth: false },
  },
  {
    path: "/signup-success",
    alias: "/signup-success",
    name: "signup-success",
    components: { public: () => import("@/views/public/SignUp/SignUpSuccessView.vue") },
    meta: { titleKey: 'page_titles.signup_success', requiresAuth: false },
  },
  {
    path: "/resend-verification",
    alias: "/resend-verification",
    name: "resend-verification",
    components: { public: () => import("@/views/public/SignUp/ResendVerificationView.vue") },
    meta: { titleKey: 'page_titles.signup_success', requiresAuth: false },
  },
  {
    path: "/forgot-password",
    alias: "/forgot-password",
    name: "forgot-password",
    components: { public: () => import("@/views/public/SignUp/ForgotPassword/ForgotPasswordView.vue") },
    meta: { titleKey: 'page_titles.forgot_password', requiresAuth: false },
  },
  {
    path: "/reset-password",
    alias: "/reset-password",
    name: "reset-password",
    components: {
      public: () => import("@/views/public/SignUp/ForgotPassword/ResetPasswordView.vue"),
    },
    props: {
      public: (route) => ({
        code: route.query.code as string,
        orgID: route.query.orgID as string,
        userID: route.query.userID as string,
      }),
    },
    meta: { titleKey: 'page_titles.reset_password', requiresAuth: false },
  },
  {
    path: "/user/verify",
    name: "user-verify",
    components: { public: () => import("@/views/private/UserVerifyView.vue") },
    meta: { titleKey: 'page_titles.user_verify', requiresAuth: false },
  },
];

export default publicRoutes;